$(document).ready(
    function () {

        $(document).on("click", ".event-cancel", function () {

            let confirm_message = $(this).data("confirm-message");

            if (!confirm(confirm_message)) {
                return false;
            }

            let formData = new FormData(document.getElementById('event_register_form'));

            $.ajax({
                type: 'POST',
                url: "/ajax/organizer_event/cancel",
                data: formData,
                async: true,
                cache: false,
                processData: false,
                contentType: false
            })
                .done(function (data) {

                    if (data.message !== undefined && data.message !== null) {
                        popupAlert();
                        setTimeout(function () {
                            document.location.href = "/organizer/events";
                        }, 1500);
                    }

                })
                .fail(function (data) {

                    if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                        document.location.href = data.responseJSON.redirect_url;
                    }

                });

            return false;

        });

    }
);